<script setup>
import { computed, ref } from 'vue';
import { appStorage } from '@shared/utils/storage.js';
import { getServiceAbbr } from '../utils/index.js'

const props = defineProps({
	isDeleteAccountModalOpen: ref(false),
	user: {
		type: Object,
		required: true,
	},
	tagEvent: {
		type: Function,
		required: true,
	},
	toggleModals: {
		type: Function,
		required: true,
	},
});
let email = "";
let errorMessage = "";
const deleteInputVal = ref("");

const deleteFieldMatches = computed(() => {
	if (!props.user?.email) { return false; }
	else if (deleteInputVal.value.trim() === props.user.email) {
		return true;
	}
});

async function deleteAccount(currentPassword) {
	errorMessage = ""; // Clear previous errors
	const service = 'study';
	props.tagEvent({where: "account page", what: "delete_account", status: props.user.created});
	 d
	const response = await fetch(`/api/users/me`, {
		method: 'DELETE',
		credentials: 'include',
		headers: { 'Content-Type': 'application/json', },
		body: JSON.stringify({ currentPassword, service }),
	});
	console.log(response);
	if (!response.ok) {
		let error;
		try { error = await response.json(); }
		catch (error) { error = { message: 'Failed to delete account' }; }
		error.status = response.status;
		errorMessage = error.message;
		console.error("error message:", error);
		throw error;
	}

	// if okay -> clear localStorage.user and redirect
	appStorage.remove("user");
	window.location.replace(`${window.location.origin}/${service}/account/deleted`);
}

function onDialogMouseDown(event) {
	// Check if click is on the dialog backdrop (not inside the modal content)
	if (event.target === event.currentTarget) {
		closeModal();
	}
}

function closeModal() {
	const dialog = document.getElementById("delete-account");
	dialog.close();
	dialog.setAttribute('data-open', false);
	props.toggleModals()
}
</script>

<template>
<dialog
	id="delete-account"
	@mousedown="onDialogMouseDown"
	:data-open="props.isDeleteAccountModalOpen"
>
	<div>
		<h2 class="my-0 error">Are you sure you want to delete your account?</h2>
		<p>Remember, we will never sell or share your data.</p>
		<p>If you&#8217;re sure you want to delete your account, enter your email address into the field below.</p>
		<form @submit.prevent="deleteAccount()" method="dialog">
			<label class="error">Email Address</label>
			<input id="delete-input" type="email" autocomplete="off" v-model="deleteInputVal">
			<button id="confirm-delete" class="btn warning wide" type="submit" :disabled="!deleteFieldMatches">Delete Account</button>
			<a @click.stop="closeModal()" class="btn wide">Cancel</a>
		</form>
	</div>
</dialog>
</template>

<style lang="scss" scoped>
#delete-account {
	background-color: var(--bg1);
	border: none;
	box-sizing: border-box;
	color: var(--text1);
	padding: 0;
	position: fixed;
	inset: 0;
	margin: 0;
	width: 100vw;
	height: auto;
	max-width: 100vw;
	max-height: unset;
}
@media(min-width: 768px) and (min-height: 480px) {
	#delete-account {
		border: 1px solid var(--border);
		border-radius: 24px;
		box-shadow: 0 30px 200px 40px rgba(0, 0, 0, 0.15), 0 30px 50px -30px rgba(0, 0, 0, 0.4), 0 30px 80px -50px rgba(0, 0, 0, 0.5);
		inset: calc(50vh - 190px) 0; // fallback
		inset: calc(50dvh - 190px) 0;
		margin: auto;
		height: unset;
		width: auto;
		max-width: 400px;
		max-height: 90vh; // fallback
		max-height: 90dvh;
	}
}
#delete-account div {
	padding: 16px;
}
#delete-account p { margin: .5rem 0; }
#delete-account label {
	margin: 1rem 0 .5rem;
	display: block;
}
#delete-account input { margin-bottom: 1rem; }
</style>
